import React, { useEffect, useState } from "react";
import { Container, Box, Checkbox, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import "./SuccessScreen.css";
import logoSmall from "../assets/logo_small.png";
import instagramIcon from "../assets/ico-instagram.svg";
import tripadvisorIcon from "../assets/ico-tripadvisor.svg";
import googleLogo from "../assets/google.ico";
import { getBusinessByQrId } from "../api/business";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getTextById, getTextByLanguage } from "../api/text";
import { getTipById, sendClientInvoice } from "../api/tip";
import { normalizeEmail, identifyTiperForTip } from "../utils/ensureTiper";
import { SERVER_URL } from "../api";
import { ME_URL } from "../utils";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import PoweredByTipify from "../components/PoweredByTipify";
import FullPageSpinner from "../components/FullPageSpinner";
import EventHeader from "../components/EventHeader";
import CommunityBlock from "../components/CommunityBlock";
import { event } from "../utils/gtag";
import * as embudo from "../utils/embudo";

/** URL absoluta para logo u otro fichero guardado en servidor (misma lógica que FormScreen). */
function resolveStoredMediaUrl(url) {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  return trimmed.startsWith("http") ? trimmed : `${SERVER_URL}/${trimmed}`;
}

const SuccessScreen = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const businessId = params.id;
  const tipId =
    params.idtip || new URLSearchParams(location.search || "").get("tipId");
  const searchParams = new URLSearchParams(location.search || "");
  const [business, setBusiness] = useState({});
  const [textCookies, setTextCoookies] = useState("");
  const [textCookiesContent, setTextCookiesContent] = useState(null);
  const [manualEmail, setManualEmail] = useState("");
  const [isSavingEmail, setIsSavingEmail] = useState(false);
  const [tip, setTip] = useState(null);
  const [askEmail, setAskEmail] = useState(false);
  const [emailSaved, setEmailSaved] = useState(false);
  const [tiperLinked, setTiperLinked] = useState(false);
  const [error, setError] = useState(null);
  const [isRatingOnly, setIsRatingOnly] = useState(false);
  const [isCheckingEvent, setIsCheckingEvent] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [eventData, setEventData] = useState(null);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
  const isTPVMode =
    searchParams.get("mode") === "tpv" || searchParams.get("tpv") === "true";

  useEffect(() => {
    // Limpiar estado del formulario al llegar a la pantalla de éxito
    try {
      sessionStorage.removeItem("tipify_form_state");
    } catch (error) {
      console.error("Error limpiando estado de sessionStorage:", error);
    }

    const fetchData = async () => {
      setIsLoading(true);
      try {
        console.log("🔍 SuccessScreen - Iniciando fetchData");
        const textRes = await getTextById("679c9c23474dd68f9a1080d9");
        if (textRes.status === 200) {
          setTextCookiesContent(textRes.data.content);
          setTextCoookies(getTextByLanguage(textRes.data.content));
        }

        if (!tipId || tipId === "undefined" || tipId === "null") {
          const errorMsg = `❌ tipId inválido: ${tipId}`;
          console.error(errorMsg);
          setError(errorMsg);
          return;
        }

        console.log(
          "🔍 SuccessScreen - Validación pasada, businessId:",
          businessId,
          "tipId:",
          tipId
        );

        let tipData = null;
        try {
          console.log("🔍 SuccessScreen - Llamando a getTipById con:", tipId);
          const tipRes = await getTipById(tipId);
          console.log("🔍 SuccessScreen - Respuesta de getTipById:", tipRes);
            if (tipRes && tipRes.status === 200 && tipRes.data) {
              console.log(
                "🔍 SuccessScreen - Tip obtenido correctamente:",
                tipRes.data
              );
              tipData = tipRes.data;
              setTip(tipData);
              
              // Tracking: pantalla de éxito cargada
              event({
                action: "cargar_pantalla_exito",
                category: "Éxito",
                label: tipData.evento ? "Evento" : tipData.tiped ? "Tiped" : "Business",
              });
              // Embudo propio: pago completado
              embudo.registrar("pago_ok", {
                tipId: tipData._id,
                negocio: typeof tipData.business === "string" ? tipData.business : tipData.business?._id,
                metodo: new URLSearchParams(location.search || "").get("method") || tipData.metodoPagoDetalle || undefined,
              });

            console.log("🔍 TipData recibido:", tipData);
            console.log(
              "🔍 TipData.evento:",
              tipData.evento,
              "Tipo:",
              typeof tipData.evento
            );

            if (tipData.evento) {
              try {
                const { getEventById } = await import("../api/event");
                const eventId =
                  typeof tipData.evento === "string"
                    ? tipData.evento
                    : tipData.evento._id || tipData.evento;

                console.log("🔍 EventId extraído:", eventId);

                if (eventId) {
                  console.log("🔍 Llamando a getEventById con:", eventId);
                  const eventRes = await getEventById(eventId);
                  console.log("🔍 Respuesta de getEventById:", eventRes);

                  if (eventRes && eventRes.status === 200 && eventRes.data) {
                    const eventDataFromApi = eventRes.data;
                    console.log("🔍 EventData recibido:", eventDataFromApi);
                    console.log(
                      "🔍 soloRatings:",
                      eventDataFromApi.soloRatings
                    );
                    setIsRatingOnly(eventDataFromApi.soloRatings === true);
                    setEventData(eventDataFromApi);
                    
                    // Si el evento tiene business, cargarlo también
                    if (eventDataFromApi.business) {
                      const businessIdFromEvent = typeof eventDataFromApi.business === "string"
                        ? eventDataFromApi.business
                        : eventDataFromApi.business._id;
                      if (businessIdFromEvent) {
                        try {
                          const { getBusinessById } = await import("../api/business");
                          const businessResFromEvent = await getBusinessById(businessIdFromEvent);
                          if (businessResFromEvent && businessResFromEvent.status === 200) {
                            console.log("🔍 SuccessScreen - Business cargado desde evento:", businessResFromEvent.data);
                            console.log("🔍 SuccessScreen - googleURL:", businessResFromEvent.data.googleURL);
                            console.log("🔍 SuccessScreen - successGoogleEnabled:", businessResFromEvent.data.successGoogleEnabled);
                            setBusiness(businessResFromEvent.data);
                          }
                        } catch (err) {
                          console.error("Error al cargar business desde evento:", err);
                        }
                      }
                    }
                    
                    console.log(
                      "✅ Evento detectado - isRatingOnly establecido a:",
                      eventDataFromApi.soloRatings === true
                    );
                  } else {
                    console.warn(
                      "⚠️ No se pudo obtener el evento. Status:",
                      eventRes?.status,
                      "Data:",
                      eventRes?.data
                    );
                    setIsRatingOnly(false);
                  }
                } else {
                  console.warn(
                    "⚠️ No se pudo extraer el eventId del tipData.evento"
                  );
                  setIsRatingOnly(false);
                }
              } catch (eventErr) {
                console.error(
                  "❌ Error al obtener información del evento:",
                  eventErr
                );
                setIsRatingOnly(false);
              } finally {
                setIsCheckingEvent(false);
                console.log("🔍 isCheckingEvent establecido a false");
              }
            } else {
              console.log(
                "🔍 No hay evento en el tip, estableciendo isRatingOnly a false"
              );
              setIsRatingOnly(false);
              setIsCheckingEvent(false);
            }

            // La API pública ya no devuelve el email, solo si existe (hasCustomerEmail)
            if (!tipRes.data.hasCustomerEmail && !tipRes.data.customerEmail) {
              setAskEmail(true);
            }
          } else {
            const errorMsg = `❌ No se pudo obtener el tip. Status: ${
              tipRes?.status
            }, Data: ${JSON.stringify(tipRes?.data)}`;
            console.error(errorMsg);
            setError(errorMsg);
            setTip(null);
            return;
          }
        } catch (tipErr) {
          const errorMsg = `❌ Error al obtener tip: ${
            tipErr?.message || tipErr
          }`;
          console.error(errorMsg, tipErr);
          setError(errorMsg);
          setTip(null);
          return;
        }

        const isEvent = tipData && tipData.evento;

        if (businessId && businessId !== "undefined" && businessId !== "null") {
          try {
            console.log(
              "🔍 SuccessScreen - Llamando a getBusinessByQrId con:",
              businessId
            );
            const businessRes = await getBusinessByQrId(businessId);
            console.log(
              "🔍 SuccessScreen - Respuesta de getBusinessByQrId:",
              businessRes
            );
            if (businessRes && businessRes.status === 200 && businessRes.data) {
              const responseData = businessRes.data;
              console.log(
                "🔍 SuccessScreen - Business obtenido correctamente:",
                responseData
              );
              if (responseData.tipo === "business" && responseData.business) {
                setBusiness(responseData.business);
              } else {
                setBusiness({});
              }
            } else {
              if (tipData && tipData.business) {
                const businessIdFromTip =
                  typeof tipData.business === "string"
                    ? tipData.business
                    : tipData.business._id;
                if (businessIdFromTip) {
                  const { getBusinessById } = await import("../api/business");
                  const businessResFromTip = await getBusinessById(
                    businessIdFromTip
                  );
                  if (businessResFromTip && businessResFromTip.status === 200) {
                    setBusiness(businessResFromTip.data);
                  } else {
                    setBusiness({});
                  }
                } else {
                  setBusiness({});
                }
              } else {
                setBusiness({});
              }
            }
          } catch (businessErr) {
            console.error("Error al obtener business desde URL:", businessErr);
            if (tipData && tipData.business) {
              const businessIdFromTip =
                typeof tipData.business === "string"
                  ? tipData.business
                  : tipData.business._id;
              if (businessIdFromTip) {
                try {
                  const { getBusinessById } = await import("../api/business");
                  const businessResFromTip = await getBusinessById(
                    businessIdFromTip
                  );
                  if (businessResFromTip && businessResFromTip.status === 200) {
                    setBusiness(businessResFromTip.data);
                  } else {
                    setBusiness({});
                  }
                } catch (err) {
                  setBusiness({});
                }
              } else {
                setBusiness({});
              }
            } else {
              setBusiness({});
            }
          }
        } else if (tipData && tipData.business) {
          const businessIdFromTip =
            typeof tipData.business === "string"
              ? tipData.business
              : tipData.business._id;
          if (businessIdFromTip) {
            try {
              const { getBusinessById } = await import("../api/business");
              const businessResFromTip = await getBusinessById(
                businessIdFromTip
              );
              if (businessResFromTip && businessResFromTip.status === 200) {
                setBusiness(businessResFromTip.data);
              } else {
                setBusiness({});
              }
            } catch (err) {
              setBusiness({});
            }
          } else {
            setBusiness({});
          }
        } else {
          setBusiness({});
        }

        if (!tipData || !tipData.evento) {
          setIsCheckingEvent(false);
        }
      } catch (err) {
        const errorMsg = `❌ Error en SuccessScreen: ${err?.message || err}`;
        console.error(errorMsg, err);
        setError(errorMsg);
        setIsCheckingEvent(false);
        // No redirigir a /error, solo loguear y mostrar en pantalla
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [businessId, tipId]);

  // Actualizar isRatingOnly cuando cambie el tip (backup en caso de que no se haya detectado antes)
  useEffect(() => {
    if (tip && tip.evento && isCheckingEvent) {
      const checkEventRatingOnly = async () => {
        try {
          const { getEventById } = await import("../api/event");
          // tip.evento puede ser un ID (string) o un objeto (si viene populate)
          const eventId =
            typeof tip.evento === "string"
              ? tip.evento
              : tip.evento._id || tip.evento;

          if (eventId) {
            const eventRes = await getEventById(eventId);
          if (eventRes && eventRes.status === 200 && eventRes.data) {
            setIsRatingOnly(eventRes.data.soloRatings === true);
            setEventData(eventRes.data);
            
            // Si el evento tiene business y aún no se ha cargado, cargarlo
            if (eventRes.data.business && !business?._id) {
              const businessIdFromEvent = typeof eventRes.data.business === "string"
                ? eventRes.data.business
                : eventRes.data.business._id;
              if (businessIdFromEvent) {
                try {
                  const { getBusinessById } = await import("../api/business");
                  const businessResFromEvent = await getBusinessById(businessIdFromEvent);
                  if (businessResFromEvent && businessResFromEvent.status === 200) {
                    console.log("🔍 SuccessScreen - Business cargado desde evento (useEffect):", businessResFromEvent.data);
                    console.log("🔍 SuccessScreen - googleURL:", businessResFromEvent.data.googleURL);
                    console.log("🔍 SuccessScreen - successGoogleEnabled:", businessResFromEvent.data.successGoogleEnabled);
                    setBusiness(businessResFromEvent.data);
                  }
                } catch (err) {
                  console.error("Error al cargar business desde evento (useEffect):", err);
                }
              }
            }
            
            console.log(
              "✅ Evento detectado en useEffect - soloRatings:",
              eventRes.data.soloRatings
            );
          } else {
              setIsRatingOnly(false);
            }
          } else {
            setIsRatingOnly(false);
          }
        } catch (err) {
          console.warn(
            "❌ Error al obtener información del evento en useEffect:",
            err
          );
          setIsRatingOnly(false);
        } finally {
          setIsCheckingEvent(false);
        }
      };
      checkEventRatingOnly();
    } else if (tip && !tip.evento) {
      setIsRatingOnly(false);
      setIsCheckingEvent(false);
    }
  }, [tip, isCheckingEvent]);

  // Actualizar texto cuando cambie el idioma
  useEffect(() => {
    if (textCookiesContent) {
      setTextCoookies(getTextByLanguage(textCookiesContent));
    }
  }, [i18n.language, textCookiesContent]);

  const handleGoogle = () => {
    // Tracking: click en botón de Google Ratings
    event({
      action: "click_google_ratings",
      category: "Éxito",
      label: "SuccessScreen",
    });
    
    if (business && business.googleURL) {
      const url = `https://search.google.com/local/writereview?placeid=${business.googleURL}`;
      window.open(url, "_blank");
    } else {
      window.open("https://www.tipify.tech", "_blank");
    }
  };

  const handleInstagram = () => {
    // Tracking: click en botón de Instagram
    event({
      action: "click_instagram",
      category: "Éxito",
      label: "SuccessScreen",
    });
    
    if (business && business.instagramURL) {
      let instagramUrl = business.instagramURL.trim();
      
      // Si viene con @, removerlo
      if (instagramUrl.startsWith("@")) {
        instagramUrl = instagramUrl.substring(1);
      }
      
      // Si no empieza con http, construir la URL completa
      if (!instagramUrl.startsWith("http")) {
        // Remover cualquier barra inicial o caracteres especiales
        instagramUrl = instagramUrl.replace(/^\/+/, "").replace(/[^a-zA-Z0-9_.]/g, "");
        instagramUrl = `https://www.instagram.com/${instagramUrl}/`;
      }
      
      window.open(instagramUrl, "_blank");
    }
  };

  const handleTripadvisor = () => {
    event({
      action: "click_tripadvisor",
      category: "Éxito",
      label: "SuccessScreen",
    });

    if (business?.tripadvisorURL) {
      let tripadvisorUrl = business.tripadvisorURL.trim();
      if (!tripadvisorUrl.startsWith("http")) {
        tripadvisorUrl = `https://${tripadvisorUrl}`;
      }
      window.open(tripadvisorUrl, "_blank");
    }
  };

  const handleSaveEmail = async () => {
    setIsSavingEmail(true);
    const normalizedEmail = normalizeEmail(manualEmail);
    if (!normalizedEmail || !normalizedEmail.includes("@")) {
      alert("Introduce un email válido.");
      setIsSavingEmail(false);
      return;
    }

    const assumesCosts = Boolean(tip?.clickTaxes);

    if (!assumesCosts && !privacyAccepted) {
      alert("Debes aceptar la política de privacidad para vincular tu email.");
      setIsSavingEmail(false);
      return;
    }

    try {
      // Asume costes sin check: solo enviar factura, no guardar email/tiper
      if (assumesCosts && !privacyAccepted) {
        await sendClientInvoice(tipId, normalizedEmail);

        event({
          action: "enviar_comprobante",
          category: "Éxito",
          label: "SuccessScreen",
        });

        setEmailSaved(true);
        setAskEmail(false);
        setTimeout(() => {
          setEmailSaved(false);
        }, 5000);
        setIsSavingEmail(false);
        return;
      }

      const currentLanguage = i18n.language || "en";
      const languageCode = currentLanguage.split("-")[0].toLowerCase();

      // El backend fusiona el tiper anónimo (cookie) con el del email,
      // guarda el consentimiento y enlaza la propina.
      const tiperId = await identifyTiperForTip({
        email: normalizedEmail,
        tipId,
        languageCode,
        consentType: "comunicaciones",
        businessId: business?._id,
      });
      setTip((prev) =>
        prev
          ? { ...prev, customerEmail: normalizedEmail, tiper: tiperId }
          : prev
      );
      setTiperLinked(true);

      // Tracking: email guardado
      event({
        action: "guardar_email",
        category: "Éxito",
        label: "SuccessScreen",
      });

      setEmailSaved(true);
      setAskEmail(false);

      setTimeout(() => {
        setEmailSaved(false);
      }, 5000);
    } catch (error) {
      console.error("Error guardando email:", error);
      alert("Error al guardar el email. Por favor, inténtalo de nuevo.");
    }

    setIsSavingEmail(false);
  };

  const isOnFreePlan = business?.planSuscripcionFree === true;
  const hasVives = business?.vives === true;
  const suppressBusinessLogoForPlan = isOnFreePlan && !hasVives;
  const businessLogoForHeader = suppressBusinessLogoForPlan
    ? null
    : resolveStoredMediaUrl(business?.logoURL);
  const headerLogoSrc = businessLogoForHeader || logoSmall;
  const headerLogoAlt = businessLogoForHeader
    ? business.nombre_comercial || "Logo"
    : "Tipify";

  if (isLoading || (isCheckingEvent && tip && tip.evento)) {
    return <FullPageSpinner />;
  }

  // 🔍 Mostrar error en pantalla si existe
  if (error) {
    return (
      <Container className="success-container">
        <div className="logo-container mt-3">
          <img
            src={headerLogoSrc}
            alt={headerLogoAlt}
            className="logo2"
            style={{ maxHeight: "80px", objectFit: "contain" }}
          />
        </div>
        <h4 className="main-text text-secondary" style={{ color: "red" }}>
          ⚠️ Error
        </h4>
        <Box
          className="mt-4 p-4"
          style={{
            backgroundColor: "#ffebee",
            borderRadius: "8px",
            border: "1px solid #f44336",
          }}
        >
          <p style={{ color: "#c62828", fontWeight: "bold" }}>
            Error detectado:
          </p>
          <p style={{ color: "#c62828" }}>{error}</p>
          <p style={{ color: "#666", fontSize: "14px", marginTop: "20px" }}>
            <strong>URL completa:</strong> {window.location.href}
          </p>
          <p style={{ color: "#666", fontSize: "14px" }}>
            <strong>businessId:</strong> {businessId || "undefined"}
          </p>
          <p style={{ color: "#666", fontSize: "14px" }}>
            <strong>tipId:</strong> {tipId || "undefined"}
          </p>
          <p style={{ color: "#666", fontSize: "12px", marginTop: "20px" }}>
            Revisa la consola del navegador para más detalles.
          </p>
        </Box>
      </Container>
    );
  }

  const businessName = business?.nombre_comercial || "";
  const showGoogle = Boolean(
    business?.googleURL && business?.successGoogleEnabled !== false
  );
  const showTripadvisor = Boolean(
    business?.tripadvisorURL && business?.successTripadvisorEnabled === true
  );
  const showInstagram = Boolean(
    business?.instagramURL && business?.successInstagramEnabled === true
  );
  const showBanner = Boolean(
    business?.successBannerImage && business?.successBannerUrl
  );

  let heroSubtitle;
  if (isRatingOnly) heroSubtitle = t("success.hero.subtitleRatingOnly");
  else if (businessName)
    heroSubtitle = t("success.hero.subtitle", { name: businessName });
  else heroSubtitle = t("success.hero.subtitleNoName");

  return (
    <Container className="success-container ss-page" maxWidth="sm">
      {/* Cabecera: evento o logo del negocio */}
      {eventData ? (
        <EventHeader
          eventData={eventData}
          businessData={business}
          showUbicacion={false}
        />
      ) : (
        <div className="ss-logo">
          <img src={headerLogoSrc} alt={headerLogoAlt} />
        </div>
      )}

      {/* Confirmación */}
      <section className="ss-hero" aria-live="polite">
        <div className="ss-check" aria-hidden="true">
          <svg viewBox="0 0 52 52">
            <circle cx="26" cy="26" r="25" />
            <path d="M15 27l7 7 15-16" />
          </svg>
        </div>
        <h1 className="ss-title">
          {isRatingOnly ? t("success.hero.titleRatingOnly") : t("success.hero.title")}
        </h1>
        <p className="ss-subtitle">{heroSubtitle}</p>
      </section>

      {/* Reseñas: lo más importante tras el pago, si el negocio las tiene activas */}
      {(showGoogle || showTripadvisor) && (
        <section className="ss-card ss-reviews">
          <div className="ss-stars" aria-hidden="true">★★★★★</div>
          <h2 className="ss-card-title">
            {businessName
              ? t("success.reviews.title", { name: businessName })
              : t("success.reviews.titleNoName")}
          </h2>
          <p className="ss-card-text">{t("success.reviews.subtitle")}</p>

          {showGoogle &&
            (!isTPVMode ? (
              <button type="button" className="ss-btn ss-btn-google" onClick={handleGoogle}>
                <img src={googleLogo} alt="" className="ss-btn-icon" />
                <div className="ss-btn-label">{t("success.google.button")}</div>
              </button>
            ) : (
              <div className="ss-qr">
                <img
                  alt="QR Google Review"
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(
                    `https://search.google.com/local/writereview?placeid=${business.googleURL}`
                  )}`}
                />
                <p className="ss-card-text">{t("success.google.scan")}</p>
              </div>
            ))}

          {showTripadvisor && (
            <button
              type="button"
              className={`ss-btn ss-btn-tripadvisor${showGoogle ? " ss-btn-second" : ""}`}
              onClick={handleTripadvisor}
            >
              <img src={tripadvisorIcon} alt="" className="ss-btn-icon" />
              <div className="ss-btn-label">{t("success.tripadvisor.button")}</div>
            </button>
          )}
        </section>
      )}

      {/* Email: comprobante o vincular la propina */}
      {emailSaved && (
        <div className="ss-notice">{t("success.email.thanks")}</div>
      )}

      {tiperLinked && (
        <a
          className="ss-btn ss-btn-outline"
          href={ME_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            event({
              action: "abrir_tipify_me",
              category: "Éxito",
              label: "SuccessScreen",
            })
          }
        >
          <div className="ss-btn-label">{t("success.email.viewInTipifyMe")}</div>
        </a>
      )}

      {askEmail && (
        <section className="ss-card ss-email">
          <h2 className="ss-card-title ss-card-title-sm">
            {tip?.clickTaxes
              ? t("success.email.receiptPrompt")
              : isRatingOnly
              ? t("success.email.questionRatingOnly")
              : t("success.email.question")}
          </h2>
          {!tip?.clickTaxes && (
            <p className="ss-card-text">{t("success.email.surprise")}</p>
          )}
          <div className="ss-email-row">
            <input
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder={t("success.email.placeholder")}
              value={manualEmail}
              onChange={(e) => setManualEmail(e.target.value)}
              className="ss-input"
            />
            <button
              type="button"
              className="ss-send"
              aria-label={t("success.email.save")}
              onClick={handleSaveEmail}
              disabled={isSavingEmail || (!tip?.clickTaxes && !privacyAccepted)}
            >
              <SendIcon fontSize="small" />
            </button>
          </div>
          <label className="ss-privacy">
            <Checkbox
              checked={privacyAccepted}
              onChange={(e) => setPrivacyAccepted(e.target.checked)}
              size="small"
              style={{ padding: "2px 6px 0 0" }}
            />
            <div>
              {t("success.email.privacyText", {
                businessName:
                  business?.nombre_fiscal || business?.nombre_comercial || "",
              })}
              <button
                type="button"
                className="ss-link"
                onClick={(e) => {
                  e.preventDefault();
                  setPrivacyModalOpen(true);
                }}
              >
                {t("success.email.privacyLink")}
              </button>
              .
            </div>
          </label>
        </section>
      )}

      {/* Comunidad del negocio (fase 2): solo si el negocio la tiene activa */}
      {!isRatingOnly && business?._id && tip?._id && (
        <CommunityBlock
          businessId={business._id}
          tipId={tip._id}
          tiperId={tip.tiper}
          emailFormVisible={askEmail}
          refreshKey={tiperLinked ? "linked" : "anon"}
        />
      )}

      {/* Instagram: secundario */}
      {showInstagram && (
        <button type="button" className="ss-btn ss-btn-ghost" onClick={handleInstagram}>
          <img src={instagramIcon} alt="" className="ss-btn-icon" />
          <div className="ss-btn-label">{t("success.instagram.button")}</div>
        </button>
      )}

      {/* Banner promocional (solo si el negocio lo ha configurado) */}
      {showBanner && (
        <section className="ss-banner">
          <button
            type="button"
            className="ss-banner-img"
            onClick={() => {
              try {
                window.open(business.successBannerUrl, "_blank");
              } catch (e) {
                console.error("Invalid banner URL", e);
              }
            }}
          >
            <div className="ss-banner-tag">{t("success.banner.tap")}</div>
            <img
              src={
                business.successBannerImage?.startsWith("http")
                  ? business.successBannerImage
                  : `${SERVER_URL}/${business.successBannerImage}`
              }
              alt={t("success.banner.title")}
            />
          </button>
        </section>
      )}

      {/* Modal de Política de Privacidad */}
      <Dialog
        open={privacyModalOpen}
        onClose={() => setPrivacyModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t("success.email.privacyModal.title")}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" style={{ marginBottom: "16px", whiteSpace: "pre-line" }}>
            {t("success.email.privacyModal.content")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setPrivacyModalOpen(false)}
            variant="contained"
            style={{ backgroundColor: "#66bc5f" }}
          >
            {t("common.close")}
          </Button>
        </DialogActions>
      </Dialog>

      <PoweredByTipify />
    </Container>
  );
};

export default SuccessScreen;
